import { useEffect, useState } from 'react';

/**
 * TUTAR GİRİŞİ — Türkçe biçimli para kutusu.
 *
 * Kullanıcı "1250", "1.250", "1.250,50" ya da "1250,5" yazar; kutudan çıkınca
 * "1.250,50" olarak biçimlenir. Değer KURUŞ (tam sayı) olarak verilir; küsurat
 * float hesabına girmez. Okunamayan metin `null` döner (çağıran "tutar yazın" der).
 */
export function tutarOku(metin: string): number | null {
  const s = metin.trim().replace(/\s|₺|€|\$/g, '');
  if (!s) return null;
  // Virgül ondalık ayracıdır; nokta binlik. Virgül yoksa ve tek nokta + 1-2 hane varsa o nokta ondalıktır ("12.5").
  let tam: string, kesir: string;
  if (s.includes(',')) {
    const [a, b = '', ...fazla] = s.split(',');
    if (fazla.length) return null;
    tam = a.replace(/\./g, ''); kesir = b;
  } else {
    const p = s.split('.');
    if (p.length === 2 && p[1].length <= 2) { tam = p[0]; kesir = p[1]; } else { tam = p.join(''); kesir = ''; }
  }
  if (!/^\d{1,12}$/.test(tam || '0') || !/^\d{0,2}$/.test(kesir)) return null;
  return Number(tam || '0') * 100 + Number(kesir.padEnd(2, '0') || '0');
}

export const tutarYaz = (kurus: number) => new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(kurus / 100);

export default function TutarGiris({ id, kurus, degis, simge = '₺', disabled, autoFocus, eksiOlur, yerTutucu = '0,00' }: {
  id?: string; kurus: number | null; degis: (kurus: number | null) => void;
  simge?: string; disabled?: boolean; autoFocus?: boolean;
  /** Açılış bakiyesi gibi eksi olabilen alanlar için. */
  eksiOlur?: boolean; yerTutucu?: string;
}) {
  const yaz = (k: number | null) => (k == null ? '' : `${k < 0 ? '-' : ''}${tutarYaz(Math.abs(k))}`);
  const [metin, setMetin] = useState(yaz(kurus));
  const [odak, setOdak] = useState(false);
  // Dışarıdan değer değişince (form sıfırlandı, öneri geldi) kutu güncellenir; yazarken dokunulmaz.
  useEffect(() => { if (!odak) setMetin(yaz(kurus)); }, [kurus, odak]); // eslint-disable-line react-hooks/exhaustive-deps

  const oku = (m: string) => {
    const eksi = Boolean(eksiOlur) && m.trim().startsWith('-');
    const k = tutarOku(m.replace('-', ''));
    return k == null ? null : eksi ? -k : k;
  };
  return (
    <div className="ccd-kasa-tutar">
      <input id={id} className="ccd-input" inputMode="decimal" autoComplete="off" disabled={disabled} autoFocus={autoFocus}
             placeholder={yerTutucu} value={metin}
             onFocus={(e) => { setOdak(true); e.target.select(); }}
             onChange={(e) => { setMetin(e.target.value); degis(oku(e.target.value)); }}
             onBlur={() => { setOdak(false); const k = oku(metin); if (k != null) setMetin(yaz(k)); }} />
      <span className="ccd-kasa-tutar-simge" aria-hidden="true">{simge}</span>
    </div>
  );
}
